import { render, staticRenderFns } from "./TaskStatusBadge.vue?vue&type=template&id=753d84c0&scoped=true"
import script from "./TaskStatusBadge.vue?vue&type=script&lang=ts"
export * from "./TaskStatusBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753d84c0",
  null
  
)

export default component.exports